import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { CreateArtifactContext } from "../../../context/CreateArtifactContext";
import { ArtifactType, ContentState, SKLinkArtifact } from "../../../models/SKArtifact";
import { useNavigationBar } from "../../../context/NavigationContext";
import { CoverImageComponent } from "./container/components/CoverImageComponent";
import LoadingPopup from "../../channels/create/LoadingPopup";
import { LinkMetadataProviderWidget } from "./container/components/LinkMetadataProviderWidget";
import { AddTextField } from "../../../components/AddTextField";
import { LinkImageProvideWidget } from "./container/components/LinkImageProvideWidget";

const CreateLinkContent = () => {
  const [isClear, setIsClear] = useState(false);
  const [linkTitle, setLinkTitle] = useState("");

  const [linkPhotoBase64, setLinkPhotoBase64] = useState("");
  const [linkId, setLinkId] = useState("");

  const [isValidInput, setIsValidInput] = useState(false);

  const [isValidForm, setIsValidForm] = useState(false);
  const { contentData, updateContentData, artifactId, saveData, loading, isEditable } = useContext(CreateArtifactContext);
  const navigate = useNavigate();
  const { setNavProps } = useNavigationBar();
  const [editable, setEditable] = useState<boolean>(true);
  useEffect(() => {
    if (contentData.status === ContentState.DRAFT) {
      setEditable(true);
    } else {
      setEditable(false);
    }
  }, [contentData]);

  useEffect(() => {
    setNavProps(prev => ({
      ...prev,
      backArrow: false,
      buttonTitle: "Done",
      title: "Add Link",
      enableLink: isEditable ? isValidForm : false,
      getActionItems: undefined,
      onNext: isEditable ? submit : undefined,
      onClose: () => navigate(-1),
      onEdit: undefined,
    }));
  }, [setNavProps, isValidForm, isEditable]);

  const submit = async () => {
    //updateContentData(prev => ({ ...prev, photoURLs: urls }));
    await saveData();
    window.history.back();
  };

  const schema = Yup.object().shape({
    webURL: Yup.string().required(),
    linkName: Yup.string().required(),
    linkImagePath: Yup.string().required(),
  });

  useEffect(() => {
    const validate = async () => {
      try {
        await schema.validate(contentData, { abortEarly: false });
        setIsValidForm(true);
      } catch (err) {
        setIsValidForm(false);
      }
    };
    validate();
  }, [contentData, schema]);

  useEffect(() => {
    if ((contentData as SKLinkArtifact) != null) {
      //setItems((contentData as SKListArtifact).listItems);
    }
  }, []);

  useEffect(() => {
    setIsValidInput(linkTitle.length >= 3 && linkId.length >= 3);
  }, [linkTitle, linkId]);

  const parseResult = async (
    data: {
      id: string;
      title: string;
      description: string;
      image: string;
      url: string;
      bufferImage: string;
    },
    actualURL: string
  ) => {
    if (data) {
      updateContentData({ webURL: actualURL, linkName: data.title, linkImagePath: data.image });
      // setLinkId(data.id);
      // setLinkTitle(data.title);
      setLinkPhotoBase64(data.bufferImage);
      // setIsValidInput(true);
    } else {
      updateContentData({ webURL: actualURL });
    }
  };

  return loading ? (
    <LoadingPopup isLoading={loading} loadingText="Saving" />
  ) : (
    <>
      <div className="flex flex-col gap-[30px] mt-[12px] max-w-[480px]">
        <div className="flex flex-col gap-[30px]">
          <div>
            <LinkMetadataProviderWidget
              index={1}
              title={"Add URL Link"}
              note={"Type or paste a valid URL link."}
              placeholder={"URL"}
              charAllowed={150}
              webAddress={(contentData as SKLinkArtifact)?.webURL ? (contentData as SKLinkArtifact)?.webURL : ""}
              isClear={isClear}
              onChange={parseResult}
            />
          </div>

          <div>
            <AddTextField
              name={"linkname"}
              title={"Add Link Name"}
              note={"System will try to auto add the link name from the URL. You can manually add or edit the link name."}
              placeholder={"Link Name"}
              index={2}
              charAllowed={150}
              value={(contentData as SKLinkArtifact)?.linkName ? (contentData as SKLinkArtifact)?.linkName : linkTitle}
              onChange={async e => {
                updateContentData({ linkName: e.target.value });
              }}
              notesclass="notes-class-content"
              disabled={contentData.status !== ContentState.IN_REVIEW ? false : true}
            />
          </div>
          <div className="flex items-center justify-center">
            <LinkImageProvideWidget
              defaultImageUrl={(contentData as SKLinkArtifact)?.linkImagePath}
              index={3}
              title={"Add Link Photo"}
              information={
                "System will try to auto add the link photo from the URL. You can manually add or edit the link photo. Recommended aspect ratio of photo is either 4:3, 1:1, or 3:4."
              }
              documentId={artifactId ?? ""}
              onCoverImageUpload={url => {
                updateContentData({ linkImagePath: url });
              }}
              itemsSize={1}
              photoBase64={linkPhotoBase64}
              isClear={isClear}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateLinkContent;
